var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.showNullHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.nullHtml)}}):_c('div',[_vm._v("\n    "+_vm._s(_vm.source.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }